export interface PaymentTermOption {
  value: string;
  label: string;
}

export const PAYMENT_TERMS: PaymentTermOption[] = [
  { value: "immediate", label: "Paiement immédiat" },
  { value: "net_7", label: "Net 7 jours" },
  { value: "net_15", label: "Net 15 jours" },
  { value: "net_30", label: "Net 30 jours" },
  { value: "net_45", label: "Net 45 jours" },
  { value: "net_60", label: "Net 60 jours" },
  { value: "cod", label: "Paiement à la livraison" },
  { value: "prepaid", label: "Prépayé" },
];

const PAYMENT_TERM_LABELS: Record<string, string> = Object.fromEntries(
  PAYMENT_TERMS.map((t) => [t.value, t.label])
);

export function getPaymentTermsLabel(value: string | null | undefined): string {
  if (!value) return "—";
  return PAYMENT_TERM_LABELS[value] ?? value;
}

export function isPresetPaymentTerm(value: string | null | undefined): boolean {
  if (!value) return false;
  return value in PAYMENT_TERM_LABELS;
}
